export const asParentPath = (path: string) => `${path}/*`;
